export default {
  SettingBaseDataCountry: {
    addCountry: '新增国家',

    table: {
      countryCode: '国家编码',
      countryName: '国家名称',
      abbreviation: '简称',
      countryAbbreviation: '国家简称',
      countryCodeText: '请输入国家编码',
      countryNameText: '请输入国家名称',
      editCountryDefinition: '编辑国家定义',
      addCountryDefinition: '新建国家定义',

    }
  }
};
